






















































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import Card from '../../../components/material/Card.vue';
import DlgArticleEmailGenerator from '@/modules/articles/_components/DlgArticleEmailGenerator.vue';
import DlgCampaignArticleDelete from '@/modules/campaignArticles/_components/DlgCampaignArticleDelete.vue';
import Loader from '@/components/Loader.vue';

@Component({
  components: {
    Loader,
    DlgCampaignArticleDelete,
    DlgArticleEmailGenerator,
    Card,
  },
})
export default class CampaignArticleList extends Vue {
  @Getter('campaignArticles/all') private articles!: any[];
  @Action('campaignArticles/readByCampaignId') private readByCampaignId!: any;
  @Action('campaignArticles/readByCampaignId') private saveArticle!: any;

  @Action('campaignArticles/update') private update!: any;

  @Prop(String) private readonly campaignId!: any;

  private loading: boolean = false;
  private dlgDelete: boolean = false;
  private selected: any = {};

  private search: string = '';

  private mounted() {
    this.refresh();
  }

  private async refresh() {
    this.loading = true;
    await this.readByCampaignId(this.campaignId);
    this.loading = false;
  }

  private getImageUrl(text: string) {
    if (!text) {
      return `/img/logo.png`;
    }
    return `https://images.ihrespezialisten.at${text.replace('full', 'resized')}`;
  }

  private deleteArticle(article: any) {
    this.selected = JSON.parse(JSON.stringify(article));
    this.dlgDelete = true;
  }

  @Watch('dlgDelete')
  private dialogWatcher() {
    this.$emit('updatedArticles');
  }

  private async moveUp(article: any) {
    this.loading = true;
    const updates: any = [];
    const oldPosition = article.position || 0;
    const newPosition = oldPosition - 1;

    if (newPosition < 0) {
      return;
    }

    this.articles[this.campaignId].some((otherArticle: any) => {
      if (otherArticle.position === newPosition || (newPosition === 0 && !otherArticle.position)) {
        updates.push(this.update({...otherArticle, position: oldPosition}));
        updates.push(this.update({...article, position: newPosition}));
        return true;
      }
      return false;
    });

    await Promise.all(updates);
    this.refresh();

    this.$emit('updatedArticles');
    this.loading = false;
  }

  private async moveDown(article: any) {
    this.loading = true;
    const updates: any = [];
    const oldPosition = article.position || 0;
    const newPosition = oldPosition + 1;

    this.articles[this.campaignId].some((otherArticle: any) => {
      if (otherArticle.position === newPosition) {
        updates.push(this.update({...otherArticle, position: oldPosition}));
        updates.push(this.update({...article, position: newPosition}));
        return true;
      }
      return false;
    });

    await Promise.all(updates);
    this.refresh();

    this.$emit('updatedArticles');
    this.loading = false;
  }
}
